import { render, staticRenderFns } from "./SCamposSelecionaveis.vue?vue&type=template&id=c720f964&scoped=true"
import script from "./SCamposSelecionaveis.vue?vue&type=script&lang=js"
export * from "./SCamposSelecionaveis.vue?vue&type=script&lang=js"
import style0 from "./SCamposSelecionaveis.vue?vue&type=style&index=0&id=c720f964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c720f964",
  null
  
)

export default component.exports